import $axios from 'axios'
import {
    documentListUri,
    docTopUri,
    recommendDistinctUri,
    createOrderUri,
    getMustAskQuestionListUri,
    addMustAskQuestionUri,
    positionContractUri,
    candidateInfoUri,
    orderListUri,
    documentPurposeUri,
    matchingListUri,
    downloadFileUri,
    recommendUri,
    getDocumentFileInfoUri,
    queryCollectedPositionList,
    isStopRecommend
} from '../config/uri'
// 候选人列表
export function getDocumentList(params) {
    return $axios.post(documentListUri, params)
}

// 候选人置顶
export function getDocTop(params) {
    return $axios.post(docTopUri, params)
}
// 候选人去重
export function getRecommendDistinct(params) {
    return $axios.post(recommendDistinctUri, params)
}
// 推荐
export function getCreateOrder(params) {
    return $axios.post(createOrderUri, params)
}
// 查询职位下的必问问题
export function getMustAskQuestionList(params) {
    return $axios.post(getMustAskQuestionListUri, params)
}
// 设置必问问题
export function getAddMustAskQuestion(params) {
    return $axios.post(addMustAskQuestionUri, params)
}
// 获取当前接单信息
export function getPositionContract(params) {
    return $axios.post(positionContractUri, params)
}
// 候选人详情
export function getCandidateInfo(params) {
    return $axios.post(candidateInfoUri, params)
}
// 接单列表
export function getOrderList(params) {
    return $axios.post(orderListUri, params)
}
// 候选人动态
export function getDocumentPurpose(params) {
    return $axios.post(documentPurposeUri, params)
}

// 职能匹配
export function getMatchingList(params) {
    return $axios.post(matchingListUri, params)
}
// 下载简历
export function getDownloadFile(data) {
    return $axios.get(downloadFileUri, { params: data })
}
//一件推人
export function getRecommend(data) {
    return $axios.post(recommendUri, data)
}


//获取附件简历
export function getDocumentFileInfo(data) {
    return $axios.post(getDocumentFileInfoUri, data)
}
//收藏职位列表
export function getQueryCollectedPositionList(data) {
    return $axios.post(queryCollectedPositionList, data)
}

//判断是否禁止推人
export function getIsStopRecommend(data) {
    return $axios.post(isStopRecommend, data)
}
